module.exports = __webpack_public_path__ + "static/media/roadmap-right-bg.e69a6b22.svg";